import { TranslationType } from '../DynamicTranslation/constants';
import type { AssetNamespace } from '../types';

export function getAssetNamespace(assetId: string | undefined) {
  return `${TranslationType.asset}-${assetId ?? 'not-defined'}` satisfies AssetNamespace;
}
